
export const missao =
  "Ajudar empresas e empreendedores a trabalhar melhor, com sistemas feitos sob medida para o problema de cada um.";

export const visao =
  "Ser referência em software e automação sob medida: a primeira empresa em que se pensa quando um processo tem gargalo e precisa de um sistema que resolva.";

export const valores = [
  {
    titulo: "Eficiência",
    texto:
      "Buscamos otimizar cada processo, solucionando gargalos e criando soluções rápidas e eficientes. Estamos comprometidos em entregar resultados consistentes que tragam agilidade e eficiência para os nossos clientes.",
  },
  {
    titulo: "Transparência",
    texto:
      "Valorizamos uma comunicação aberta e honesta, garantindo que nossos clientes sempre saibam o que esperar. Buscamos construir uma relação de confiança, onde a clareza é fundamental para o sucesso de cada projeto.",
  },
  {
    titulo: "Inovação Contínua",
    texto:
      "Acreditamos que a inovação é a chave para resolver problemas de forma criativa. Estamos sempre em busca de novas tecnologias e soluções para manter nossos sistemas atualizados, eficientes e adaptáveis às necessidades do mercado.",
  },
  {
    titulo: "Sucesso do Cliente",
    texto:
      "O sucesso do cliente é o nosso principal objetivo. Focamos em entender seus desafios e oferecer soluções que resolvem seus problemas de maneira prática e eficiente, sempre garantindo o suporte necessário para atingir resultados tangíveis.",
  },
  {
    titulo: "Compromisso Total",
    texto:
      "Não temos braço curto: fazemos o que tem que ser feito sem reclamar ou dar desculpa. Nosso foco é a entrega e o comprometimento com a qualidade, independentemente dos desafios que surgirem no caminho.",
  },
];
